import { Component } from '@angular/core';

@Component({
    selector: 'app-home-enus',
    templateUrl: 'home-enus.component.html',
    styleUrls: ['home-enus.component.scss'],
    standalone: false
})
export class HomeEnusComponent {    
}
